import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { IoIosGlobe } from "react-icons/io";
import { BsBriefcase } from "react-icons/bs";
import { SlLocationPin } from "react-icons/sl";
import { FaArrowLeft } from "react-icons/fa";
import "../StuStyles/Stuviewjob.css";

const StudentJobApplyView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { jobId } = useParams();

  /* === GET JOB === */
  let job = location.state?.job;

  if (!job) {
    const hrJobs = JSON.parse(localStorage.getItem("AllPostedJobs")) || [];
    const adminJobs =
      JSON.parse(localStorage.getItem("AdminPostedJobs")) || [];

    job = [...hrJobs, ...adminJobs].find(
      (j) => String(j.id) === String(jobId)
    );
  }

  if (!job) {
    return <p className="text-center mt-5">No job details found</p>;
  }

  /* === NORMALIZED VALUES === */
  const experience = job.experienceMin
    ? `${job.experienceMin}-${job.experienceMax} years`
    : job.exp;

  const salary = job.salary
    ? job.salary
    : `${job.salaryMin} - ${job.salaryMax} LPA`;

  const rolesArray = Array.isArray(job.roles)
    ? job.roles
    : job.roles
    ? job.roles.split("\n")
    : [];

  const skillsText = Array.isArray(job.skills)
    ? job.skills.join(", ")
    : job.skills;

  return (
    <div className="jobview-wrapper">
      {/* === HEADER === */}
      <div className="jobview-header">
        <FaArrowLeft
          className="jobview-back"
          onClick={() => navigate(-1)}
        />

        <h2>{job.title}</h2>

        <p className="jobview-sub">
          <IoIosGlobe /> {job.department || job.type} &nbsp;&nbsp;
          <BsBriefcase /> {experience} &nbsp;&nbsp;
          <SlLocationPin /> {job.jobLocation || job.location}
        </p>
      </div>

      {/* === CONTENT === */}
      <div className="jobview-content">

        <Section title="Roles & Responsibilities">
          <ul>
            {rolesArray.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </Section>

        <Section title="Required Skills">
          <p>{skillsText}</p>
        </Section>

        <Section title="Qualification Required">
          <p>{job.qualification}</p>
        </Section>

        <Section title="Salary Range">
          <p>{salary}</p>
        </Section>

        <Section title="Perks & Benefits">
          <ul>
            {job.perks?.map((perk, index) => (
              <li key={index}>{perk}</li>
            ))}
          </ul>
        </Section>

        <Section title="Job Location / Area">
          <p>{job.jobLocation}</p>
        </Section>

        <Section title="Job Locality">
          <p>{job.jobLocality}</p>
        </Section>

        <Section title="Number of Openings">
          <p>{job.openings}</p>
        </Section>

        <Section title="Application Deadline">
          <p>{job.deadline}</p>
        </Section>

      </div>
    </div>
  );
};

/* === SECTION COMPONENT === */
const Section = ({ title, children }) => (
  <div className="jobview-section">
    <h4>{title}</h4>
    {children}
  </div>
);

export default StudentJobApplyView;
